<div id="error" class="container">
  <div class="header-title">
    <mat-icon>sentiment_dissatisfied</mat-icon>
    <h6 class="title-large" i18n="@@Somethingwentwrong">
      {{"Something went wrong" | translate}}
    </h6>
    <app-button-extra (click)="close()" [type]="'icon'">
      <i [mat-dialog-close]="false" class="ic-x-sm ic-cancel"></i>
    </app-button-extra>
  </div>
  <div class="content">
    <p i18n="@@Systemerror,pleasetryagaininafewminutes">
      {{"System error, please try again in a few minutes" | translate}}
    </p>
  </div>
  <div class="actions">
    <app-button-default (click)="close()" size="lg" type="dark" i18n="@@Close"
      >{{"Close" | translate}}</app-button-default
    >
  </div>
</div>
